import legend from "../assets/legend.svg"
import "./Legend.css"
import React from 'react'

export default function Legend(){


    return (

        <div className='legend' data-testid="legend-test">
            <img src={legend}></img>
        </div>
    )
}